import {
  IWidgetFormTopPage,
  IWidgetFormTopPageBO,
  TypeNameBlockWidgetFormTopPage,
  WidgetFormWorkType,
} from '../../components/widget-form-top-page/widget-form-top-page';
import { MediaImagePresenter } from '../commons/media-image.presenter';
import { RTEPresenter } from '../commons/rte.presenter';
import { IBlockPresenter } from '../presenter';

export class BlockWidgetFormTopPagePresenter implements IBlockPresenter {
  parse(data: IWidgetFormTopPageBO): IWidgetFormTopPage {
    // avoid empty / undefined data
    if (!data) {
      return null;
    }

    const block: IWidgetFormTopPage = {
      __typename: TypeNameBlockWidgetFormTopPage,
      id: data.id,
      title: data.title || '',
      description: RTEPresenter.getRTEText(data.description),
      mediaCover: MediaImagePresenter.getImageWebp(data.mediaCover),
      enableTrustPilot: data.enableTrustPilot || false,
      formTitle: data.formTitle || '',
      formDescription: data.formDescription || '',
      workType: data.workType || WidgetFormWorkType.WoodStove,
    };
    return block;
  }
}
